module.exports = __webpack_public_path__ + "img/facebook.243344a8.png";